import clsx from 'clsx'
import React from 'react'
interface Props {
  label: string
  checked?: boolean
  disabled?: boolean
  black?: boolean
  denim?: boolean
  onChange?: (checked: boolean) => void
}

const CheckBox = React.forwardRef<HTMLInputElement, Props>(
  ({ label, checked = false, onChange, disabled = false, black, denim }, ref) => {
    const handleOnChange = (
      event: React.ChangeEvent<HTMLInputElement>
    ): void => {
      onChange && onChange(event.target.checked)
    }

    return (
      <div className={`group relative pr-3 sm:pr-10 last:pr-0`}>
        <label className="flex items-baseline cursor-pointer">
          <div
            className={clsx(
              'flex items-center justify-center w-3 h-3 rounded-sm border-solid border',
              {
                'border-white': !black && !denim,
                'border-black': black && !denim,
                'border-denim': denim,
              }
            )}
          >
            <div
              className={clsx('w-2 h-2 rounded-sm', {
                'bg-white': checked && !black && !denim,
                'bg-black': checked && black && !denim,
                'bg-denim': checked && denim,
              })}
              aria-hidden="true"
            />
          </div>

          <span
            className={clsx(`pl-2 ${ denim ? '' :'font-bold' } cursor-pointer font-openSans flex-1`, {
              'text-white': !black && !denim,
              'text-black': black && !denim,
              'text-denim': denim,
            })}
          >
            {label}
          </span>
          
          <input
            type="checkbox"
            disabled={disabled}
            onChange={handleOnChange}
            checked={checked}
            className="cursor-pointer absolute opacity-0 h-0 w-0"
            ref={ref}
          />
        </label>
      </div>
    )
  }
)

CheckBox.displayName = 'CheckBox'

export default CheckBox
